import React from 'react';

const ICONS = {
  TECHNICAL: { symbol: '⚙', label: 'Technical Product', color: '#6366f1' },
  COMMERCIAL: { symbol: '💼', label: 'Commercial Product', color: '#0ea5e9' },
  PACKAGE: { symbol: '📦', label: 'Package', color: '#f59e0b' },
};

const ProductTypeIcon = ({ productType, size = 16 }) => {
  const icon = ICONS[productType] || ICONS['COMMERCIAL'];
  return (
    <span
      title={icon.label}
      style={{ fontSize: size, marginRight: 4, cursor: 'default' }}
    >
      {icon.symbol}
    </span>
  );
};

export default ProductTypeIcon;
